import { type ButtonHTMLAttributes } from 'react'
import clsx from 'clsx'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  children?: string
  activated?: boolean
}

export const ButtonPage = ({ children, activated, ...props }: Props) => {
  return (
    <button
      className={clsx('text-grey-700', {
        'text-primary-light font-bold': activated,
      })}
      {...props}
    >
      {children}
    </button>
  )
}
